import { render, staticRenderFns } from "./HealthCheckConfig.vue?vue&type=template&id=5985feb1&"
import script from "./HealthCheckConfig.vue?vue&type=script&lang=ts&"
export * from "./HealthCheckConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports